export const MOBILE_SCREEN_VALUE = 800;

export const PROJECTS_LIST = [
  {
    title: "honesthome",
    desc: "A full-stack real estate platform designed to improve price transparency in the property market. Users can share apartment prices, review buildings and developers, and publish listings for both primary and secondary market properties.",
    url: ["https://github.com/superkacper4/honest-home"],
  },
  {
    title: "rap gra",
    desc: "A browser game inspired by Shakes & Fidget, in which players develop their rap career by creating songs, gaining fans, and improving their skills. The game features character progression, music labels, equipment, statistics, a shop, and an auction system for trading items with other players.",
    url: ["https://github.com/superkacper4/rap-gra-remix"],
  },
  {
    title: "VSCD - Version System Control of Documentation",
    desc: "Application which allows you to control version of tech documentation and also to split one big repository into smaller components",
    url: ["https://github.com/superkacper4/vscd_remix"],
  },
  {
    title: "Trivia Challenge",
    desc: "Website made as pixel-perfect project with external API for questions. App is made with React. ",
    url: [
      "https://github.com/superkacper4/trivia-challenge",
      "https://superkacper4.github.io/trivia-challenge/#/",
    ],
  },
  {
    title: "E-commerce",
    desc: "E-commerce website - from user side. It simulates filtering, sorting adding to cart and filling up form with delivery data",
    url: ["https://github.com/superkacper4/E-commerce"],
  },
  {
    title: "Witcher Story Webiste",
    desc: "First webiste with React. Website has great design and tells short story about Witchers. ",
    url: [
      "https://github.com/superkacper4/witcher-story-website",
      "https://superkacper4.github.io/witcher-story-website/",
    ],
  },
  {
    title: "Clicker",
    desc: "Simple version of popular games called clickers. You touch Bee and earn money, to buy boosts, to earn money faster :) ",
    url: [
      "https://github.com/superkacper4/clicker",
      "https://superkacper4.github.io/clicker/",
    ],
  },
  {
    title: "E-learn",
    desc: "Website for language school to learn other languages. Web has landing page and course lesson with quiz in the end of all lessons.",
    url: [
      "https://github.com/superkacper4/e-learn",
      "https://superkacper4.github.io/e-learn/",
    ],
  },
  {
    title: "Estne Website",
    desc: "Website for Estne. Landing page without any frameworks",
    url: [
      "https://github.com/superkacper4/estne-website",
      "http://www.estne.com.pl/",
    ],
  },
];
